import React, { useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  Text,
  Button,
  Box,
  Checkbox
} from '@chakra-ui/react';
import { TrainGroupsType } from '../Table/MaintenanceTrainGroupsTable';
import { UpdateTrainGroupsApi } from '../../../../apis/UpdateMaintenance.api';
import {
  BanInputType,
  CustomStringInput
} from '../../../atoms/CustomStringInput';
import { AxiosError } from 'axios';

interface props {
  isOpen: boolean;
  onClose: () => void;
  EditData: TrainGroupsType | undefined;
  setMaintenanceDatas: React.Dispatch<
    React.SetStateAction<TrainGroupsType[] | null | undefined>
  >;
  CreateOrUpdateStateSwitch: () => void;
}
interface ResponseType {
  success: boolean;
  data: TrainGroupsType[] | null;
  message: unknown | null;
}

const GetTrainGroupInputCheckData = (addData: string | undefined) => {
  if (addData === undefined) {
    return { Length: 6, BanInputType: BanInputType.None, Value: '' };
  }
  return { Length: 6, BanInputType: BanInputType.None, Value: addData };
};

const TrainGroupsEditWindow: React.FC<props> = (props) => {
  const {
    isOpen,
    onClose,
    EditData,
    setMaintenanceDatas,
    CreateOrUpdateStateSwitch
  } = props;
  const [trainGroup, setTrainGroup] = useState(EditData?.name);
  const [lowFloorCheck, setLowFloorCheck] = useState(
    EditData?.low_floor_flg ? true : false
  );

  const PostApi = async () => {
    if (EditData !== undefined && EditData.id !== undefined) {
      const response: ResponseType = await UpdateTrainGroupsApi(EditData.id, {
        name: trainGroup,
        low_floor_flg: lowFloorCheck
      });

      if (
        response.message !== null &&
        (response.message as AxiosError).status?.toString() === '409'
      ) {
        alert('既に登録されている形式です。');
        return;
      } else if (response.success === false) {
        alert('編集に失敗しました。');
        return;
      }
      setMaintenanceDatas(response.data as TrainGroupsType[]);
      CreateOrUpdateStateSwitch();
      onClose();
    }
  };
  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent h='260px' maxW='1100px'>
          <ModalHeader
            textAlign='center'
            bg='gray.800'
            color='white'
            fontSize='16'
          >
            車両形式を編集
          </ModalHeader>
          <ModalCloseButton color='white' />
          <ModalBody>
            <Box
              position='relative'
              display='grid'
              gridTemplateColumns='1fr 6fr'
            >
              <Text mt={4}>形式</Text>
              <CustomStringInput
                CheckInfo={GetTrainGroupInputCheckData(
                  EditData?.name?.toString()
                )}
                inputValue={trainGroup}
                setValue={setTrainGroup}
                PhohibitionCharaCheck={false}
              />
              <Text mt={4}>低床車両</Text>
              <Checkbox
                mt={4}
                isChecked={lowFloorCheck}
                onChange={(e) => setLowFloorCheck(e.target.checked)}
              ></Checkbox>
            </Box>
            <Button mt={10} onClick={() => PostApi()}>
              更新
            </Button>
            <Button mt={10} ml={10} onClick={() => onClose()}>
              取り消す
            </Button>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
};
export default React.memo(TrainGroupsEditWindow);
